import {ChangeDetectionStrategy, Component, computed, input, output} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {Opplasting} from "../../../../../felles-ng2/tjenester/filopplasting/SekvensiellFilopplasting";
import {DokumentFormatIkonKomponent} from "../dokument-format-ikon/dokument-format-ikon";
import {MatIcon} from "@angular/material/icon";
import {MatTooltip} from "@angular/material/tooltip";
import {TranslateModule} from "@ngx-translate/core";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {MatButton} from "@angular/material/button";

const debug = initDebugger('DokumentOpplastingListevisningKomponent');

/**
 * Listevisning av dokument som er i ferd med å lastes opp
 */
@Component({
    selector: 'dokument-opplasting-listevisning',
    templateUrl: 'dokument-opplasting-listevisning.html',
    styleUrl: 'dokument-opplasting-listevisning.scss',
    host: {
        '[class]': 'opplasting().status()',
        'data-testid': 'dokument-opplasting'
    },
    imports: [
        DokumentFormatIkonKomponent,
        MatIcon,
        MatTooltip,
        TranslateModule,
        MatProgressSpinner,
        MatButton
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DokumentOpplastingListevisningKomponent<M> {

    vedAvbryt = output();
    opplasting = input.required<Opplasting<M>>();

    visAvbryt = computed(() => ['venter', 'lasteropp'].includes(this.opplasting().status()));

    constructor() {
    }

    avbryt() {
        this.vedAvbryt.emit();
    }
}
